import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=22b4ffca&"
import script from "./custom-select.vue?vue&type=script&lang=js&"
export * from "./custom-select.vue?vue&type=script&lang=js&"
import style0 from "./custom-select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports